export default "__VITE_ASSET__BBAoEJ31__";